export default __webpack_public_path__ + "static/media/delete.6a5d400b.svg";